module.exports = __webpack_public_path__ + "img/pre_page_arrow.7b94c1d7.svg";